/**
 *
 * 组件基类，所有可操作对象均继承自该组件
 * @export
 * @class Component
 */
export default class Component {
  constructor() {
    this.CLASS_NAME = this.constructor.name;
  }

  /**
   *
   * 销毁方法
   * @memberof Component
   */
  destroy() {}
}
